'use strict';

angular.module('clientDashboardApp').service('locationMgmtService', function ($q, $http) {
    function LocationMgmtService() {
    }

    LocationMgmtService.prototype.locationEditorData = function () {
      const deferred = $q.defer();

      $http
            .get('/admin/location/editorData')
            .success(function (data, status, headers, config) {
                deferred.resolve(data);
            })
            .error(function (data, status, headers, config) {
                deferred.reject('Error occurred while summary!');
            });

        return deferred.promise;
    };

    LocationMgmtService.prototype.yelpCategories = function () {
      const deferred = $q.defer();

      $http
        .get('/locations/yelpCategories')
        .success(function (data) {
          deferred.resolve(data);
        })
        .error(function () {
          deferred.reject('Error occurred while summary!');
        });

      return deferred.promise;
    }


    LocationMgmtService.prototype.facebookCategories = function () {
      const deferred = $q.defer();

      $http
        .get('/listingManagement/facebook/categories')
        .success(function (data) {
          deferred.resolve(data);
        })
        .error(function () {
          deferred.reject('Error occurred while summary!');
        });

      return deferred.promise;
    }

    LocationMgmtService.prototype.lastDataIngestionJob = function (locationId) {
      const deferred = $q.defer();

      $http
        .get(`/listingManagement/yelp/jobStatus/${locationId}`)
        .success(function (data) {
          deferred.resolve(data);
        })
        .error(function () {
          deferred.resolve('Error occurred while summary!');
        });

      return deferred.promise;
    }

    LocationMgmtService.prototype.locationYelpCategories = function (locationId) {
      const deferred = $q.defer();

      $http
        .get(`/listingManagement/yelp/${locationId}/categories`)
        .success(function (data) {
          deferred.resolve(data);
        })
        .error(function () {
          deferred.reject('Error occurred while summary!');
        });

      return deferred.promise;
    }

    return new LocationMgmtService();
});
